





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Project } from "@/models/project";

@Component({ name: "PortfolioProjectOverview" })
export default class PortfolioProjectOverview extends Vue {
  @Prop() readonly project!: Project;

  get ebitda() {
    return this.project.ebitda
  }

  get ebitdaRatio() {
    // FIXME this is not calculated, it's something related to any/Object/TypeScript class/promise resolve/...
    return this.project.ebitda_ratio
  }

  get ebitdaVariant() {
    if (this.project.ebitda < 0) {
      return "danger"
    }
    if (this.project.wps_done > 0 && this.project.ebitda/this.project.wps_done < 0.5) {
      return "warning"
    } else {
      return "success"
    }
  }

  get wps() {
    return this.project.wps_done
  }

  get wpsRatio() {
    return this.wps/this.wpsTotal * 100
  }

  get wpsTotal() {
    return this.project.wps_total
  }

  get cost() {
    return this.project.normalized_cost
  }

  get capHours() {
    return this.project.effort_cap
  }

  get doneRatio() {
    return this.project.done_ratio
  }

  get doneRatioVariant() {
    return this.$options.filters?.percentageVariant(this.project.done_ratio)
  }

}
